// imports
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'

// utils
import store from '@/utils/store/store'
import initializeConsoleSecurity from '@/utils/consoleSecurity'
import initScrollbarVisibility from '@/utils/scrollbarVisibility'

import { ModalProvider } from './contexts/modalContext'
import { ConfigProvider } from './contexts/configContext'
import { ConsentProvider } from './contexts/consentContext'
import { AuthenticationProvider } from './contexts/authenticationContext'
import { SpaceProvider } from './contexts/spaceContext'
import { NavigationProvider } from './contexts/navigationContext'

// styles
import '@/styles/index.scss'
import { GenericStoreProvider } from './contexts/genericStoreContext'

initializeConsoleSecurity()
initScrollbarVisibility()

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js')
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <Provider store={store}>
        <ConsentProvider>
            <GenericStoreProvider>
                <ModalProvider>
                    <ConfigProvider>
                        <AuthenticationProvider>
                            <SpaceProvider>
                                <NavigationProvider />
                            </SpaceProvider>
                        </AuthenticationProvider>
                    </ConfigProvider>
                </ModalProvider>
            </GenericStoreProvider>
        </ConsentProvider>
    </Provider>
)
